// TODO : add swiper slider or daisyui slider
import BottomNavigation from '../components/BottomNavigation';
import { useCallback, useEffect, useState } from 'react';
import Header from '../components/Header';
import friendsIcon from '/friends.svg';
import telegramIcon from '/telegram.svg';
import tudIcon from '/tud.svg';
import giftIcon from '/gift.svg';
import listAltCheckIcon from '/list_alt_check.svg';
import contentCopyIcon from '/content_copy.svg';
import alarmIcon from '/alarm.svg';
import { useSiteData } from '../context/SiteDataContext';
import { ShowPromiseResult } from '../types/adsgram';
import { useAdsgram } from '../hooks/useAdsgram';

const TasksPage = () => {
  const site = useSiteData();
  const [currentSlide, setCurrentSlide] = useState(1);

  const [canClaimAds, setCanClaimAds] = useState(true);
  const [remainingTime, setRemainingTime] = useState<string | null>(null);

  const isTaskCompleted = (taskType: string, taskId: string) => {
    const tasks = site.data.user.task[taskType] || [];
    return tasks.some((task: any) => task.taskId === taskId && task.completed);
  };  

  useEffect(() => {
    const ads = site.data.user.task.ads;

    if (ads && ads.length > 0) {
        const oldestAdTime = new Date(ads[0].time);
        const nextAdsAvailableTime = new Date(oldestAdTime.getTime() + 60 * 60 * 1000);

        const updateRemainingTime = () => {
            const now = new Date();
            const timeDiff = nextAdsAvailableTime.getTime() - now.getTime();
            if (ads.length >= 5 && timeDiff > 0) {
                const hours: number = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
                const minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
                const seconds = Math.floor((timeDiff / 1000) % 60);
                const timeString = `${minutes}m ${seconds}s`;
                setRemainingTime(hours > 0 ? `${hours}h ${timeString}` : timeString);
                setCanClaimAds(false);
            } else {
                setCanClaimAds(true);
                setRemainingTime(null);
            }
        };

        updateRemainingTime();
        const interval = setInterval(updateRemainingTime, 1000);

        return () => clearInterval(interval);
    } else {
        setCanClaimAds(true);
        setRemainingTime(null);
    }
}, [site.data.user.task]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev % 3) + 1);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const element = document.getElementById(`slide${currentSlide}`);
    element?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }, [currentSlide]);

  const onReward = useCallback(() => {
    const result = site.claimReward('ads', 'ads');

    console.log('Reward', result);
  }, []);

  const onError = useCallback((result: ShowPromiseResult) => {
    console.log('Error', result);
  }, []);

  const showAd = useAdsgram({ blockId: "7261", onReward, onError });

  const handleCopyLink = () => {
    navigator.clipboard.writeText('https://t.me/tonupordownbot?start=ref_' + site.data.user.id);
  }

  
  function openLink(link: string) {
    site.webApp?.openLink?.(link);
  }
  
  function openTelegramLink(link: string) {
    site.webApp?.openTelegramLink?.(link);
  }

  const claimReward = async (task_type: string, task_id: string) => {
    if (task_type === 'telegram') {
      openTelegramLink("https://t.me/" + task_id);
    } else if (task_type === 'twitter') {
      openLink("https://x.com/" + task_id);
    }

    if (isTaskCompleted(task_type, task_id)) return;
    
    site.claimReward(task_type, task_id);
  }

  return (
    <div className="flex flex-col h-screen !bg-[#0F1620] text-white">
      <div className="flex-1 overflow-y-auto p-4">
        <Header />

        <div className="w-full flex items-center flex-wrap relative h-[160px] justify-center mb-4">
          <div className="carousel !m-0 !p-0 w-full bg-blue-600 rounded-lg h-full">
            <div id="slide1" className="carousel-item flex flex-wrap overflow-hidden w-full bg-[url('/s1.png')] bg-cover bg-center" >
              <div className="p-2">
                <h3 className="text-lg w-full font-semibold mb-2 text-white">
                  #STON_LISTING
                </h3>
                <p className="mb-4 w-full text-white">
                  TUD is now listed on STON LISTING! You could trade it now without any limits.
                </p>
              </div>
            </div>
            <div id="slide2" className="carousel-item flex flex-wrap overflow-hidden w-full bg-[url('/s2.png')] bg-cover bg-center">
              <div className="p-2">
                <h3 className="text-lg font-semibold mb-2 text-white">
                  #INVITE_FRIEND
                </h3>
                <p className="mb-4 text-white">
                  Invite your friend and get +90% ⭐️ this is limited and will be removed soon. so dont miss it.
                </p>
              </div>
            </div>
            <div id="slide3" className="carousel-item flex flex-wrap overflow-hidden w-full bg-[url('/s3.png')] bg-cover bg-center">
              <div className="p-2">
                <h3 className="text-lg font-semibold mb-2 text-white">
                  #FUND_RAISING
                </h3>
                <p className="mb-4 text-white">
                  TON UP OR DOWN raised fund from some private investors. so we could make it greater than ever for you.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border border-[#50A8EB] bg-[url('/bg-gradient.png')] bg-cover bg-center rounded-lg p-4 mb-4">
          <h3 className="text-lg font-semibold mb-2 flex items-center text-white">
            <img src={giftIcon} alt="" className="w-6 h-6 mr-2" />Special Reward
          </h3>
          <p className="mb-4 text-white">
            Watch all the videos now and grab +25 TUD Tokens instantly! (You can do this every hour)
          </p>
          {canClaimAds ? (
            <button
              className={`w-full bg-[#50A8EB] text-white py-2 px-4 rounded-lg`}
              disabled={!canClaimAds}
              onClick={showAd}
            >
              Claim +5 TUD
            </button>
          ) : (
            <button
              className={`w-full bg-[#283039] text-[#F0F0F0] py-2 px-4 rounded-lg flex items-center justify-center`}
              disabled={!canClaimAds}
            >
              <img src={alarmIcon} alt="" className="w-5 h-5 mr-2" /> {remainingTime}
            </button>
          )}
        </div>

        <div className="rounded-lg mb-4">
          <h3 className="text-lg font-semibold mb-4 flex items-center">
            <img src={listAltCheckIcon} alt="" className="w-6 h-6 mr-2" /> TUD Tasks:
          </h3>
          <ul className="space-y-2">
            <li className="bg-[rgba(113,171,255,0.05)] rounded-lg p-2">
              
              <div className="flex justify-between items-center mb-4">
                <div className="flex items-center">
                  <span className="flex items-center w-12 h-12 bg-[rgba(80,168,235,0.1)] rounded-full justify-center me-2">
                    <img src={friendsIcon} alt="" className="w-6 h-6" />
                  </span>
                  Invite your friend
                </div>
                <span className="flex items-center text-bold">
                  +90% ⭐️
                </span>
              </div>
              <button className="w-full bg-[#50A8EB1A] text-[#50A8EB] backdrop-blur py-2 px-4 rounded-lg flex items-center justify-center" onClick={handleCopyLink}>
                <img src={contentCopyIcon} alt="" className="w-5 h-5 mr-2" />
                Copy Referral Link
              </button>
            </li>
            <li className="flex justify-between items-center bg-[rgba(113,171,255,0.05)] rounded-lg p-2" onClick={() => claimReward('telegram', 'tonupordown')}>
              <div className="flex items-center">
                <span className="flex items-center w-12 h-12 bg-[rgba(80,168,235,0.1)] rounded-full justify-center me-2">
                  <img src={telegramIcon} alt="" className="w-6 h-6" />
                </span>
                <span className="">
                  <span>Join @tonupordown</span>
                  <span className="text-blue-500 flex items-center">
                    +30 <img src={tudIcon} alt="" className="w-5 h-5 ms-1" />
                  </span>
                </span>
              </div>
              <button
                className="p-2 bg-[#50A8EB1A] text-[#50A8EB] backdrop-blur rounded-lg flex items-center justify-center"
                disabled={isTaskCompleted('telegram', 'tonupordown')}
              >
                {isTaskCompleted('telegram', 'tonupordown') ? "Done" : "Claim"}
              </button>
            </li>
            <li className="flex justify-between items-center bg-[rgba(113,171,255,0.05)] rounded-lg p-2" onClick={() => claimReward('telegram', 'tudgroup')}>
              <div className="flex items-center">
                <span className="flex items-center w-12 h-12 bg-[rgba(80,168,235,0.1)] rounded-full justify-center me-2">
                  <img src={telegramIcon} alt="" className="w-6 h-6" />
                </span>
                <span className="">
                  <span>Join @tudgroup</span>
                  <span className="text-blue-500 flex items-center">
                    +30 <img src={tudIcon} alt="" className="w-5 h-5 ms-1" />
                  </span>
                </span>
              </div>
              <button
                className="p-2 bg-[#50A8EB1A] text-[#50A8EB] backdrop-blur rounded-lg flex items-center justify-center"
                disabled={isTaskCompleted('telegram', 'tudgroup')}
              >
                {isTaskCompleted('telegram', 'tudgroup') ? "Done" : "Claim"}
              </button>
            </li>
            <li className="flex justify-between items-center bg-[rgba(113,171,255,0.05)] rounded-lg p-2" onClick={() => claimReward('twitter', 'tonupordown')}>
              <div className="flex items-center">
                <span className="flex items-center w-12 h-12 bg-[rgba(80,168,235,0.1)] rounded-full justify-center me-2">
                  <img src={telegramIcon} alt="" className="w-6 h-6" />
                </span>
                <span className="">
                  <span>Follow @tonupordown</span>
                  <span className="text-blue-500 flex items-center">
                    +30 <img src={tudIcon} alt="" className="w-5 h-5 ms-1" />
                  </span>
                </span>
              </div>
              <button
                className="p-2 bg-[#50A8EB1A] text-[#50A8EB] backdrop-blur rounded-lg flex items-center justify-center"
                disabled={isTaskCompleted('twitter', 'tonupordown')}
              >
                {isTaskCompleted('twitter', 'tonupordown') ? "Done" : "Claim"}
              </button>
            </li>
          </ul>
        </div>

        <div className="rounded-lg mb-4">
          <h3 className="text-lg font-semibold mb-4 flex items-center">
            <img src={listAltCheckIcon} alt="" className="w-6 h-6 mr-2" /> Partners Tasks:
          </h3>
          <ul className="space-y-2">
            {/* <li className="bg-[rgba(113,171,255,0.05)] rounded-lg p-2">
            <adsgram-task data-block-id='task-11010' data-debug='true' className='task'>
              <p slot='reward' className='task__reward'>🪙 100</p>
              <div slot='button' className='task__button'>go</div>
              <div slot='done' className='task__button task__button_done'>done</div>
            </adsgram-task>
            </li> */}

            <li className="flex justify-between items-center bg-[rgba(113,171,255,0.05)] rounded-lg p-2" onClick={() => openTelegramLink('tonstorage')}>
              <div className="flex items-center">
                <span className="flex items-center w-12 h-12 bg-[rgba(80,168,235,0.1)] rounded-full justify-center me-2">
                  <img src={telegramIcon} alt="" className="w-6 h-6" />
                </span>
                <span className="flex flex-col">
                  <span>Zeusnet</span>
                  <span className="text-gray-400 text-sm">
                    Mining $ZNT on Zeusnet
                  </span>
                </span>
              </div>
              <button className="p-2 bg-[#50A8EB1A] text-[#50A8EB] backdrop-blur rounded-lg flex items-center justify-center"
              onClick={() => openTelegramLink('https://t.me/zeusnet_app_bot/zeusnet?startapp=FNFDIITB5F')}>
                Join
              </button>
            </li>

            <li className="flex justify-between items-center bg-[rgba(113,171,255,0.05)] rounded-lg p-2" onClick={() => openTelegramLink('tonstorage')}>
              <div className="flex items-center">
                <span className="flex items-center w-12 h-12 bg-[rgba(80,168,235,0.1)] rounded-full justify-center me-2">
                  <img src={telegramIcon} alt="" className="w-6 h-6" />
                </span>
                <span className="flex flex-col">
                  <span>Pump Meme</span>
                  <span className="text-gray-400 text-sm">
                    Find trending memes and pump them!
                  </span>
                </span>
              </div>
              <button className="p-2 bg-[#50A8EB1A] text-[#50A8EB] backdrop-blur rounded-lg flex items-center justify-center"
              onClick={() => openTelegramLink('https://t.me/pumpmeme_bot/app?startapp=LUHd7ydfodXXnzZxAZ98q1k')}>
                Join
              </button>
            </li>

            {/* <li className="flex justify-between items-center bg-[rgba(113,171,255,0.05)] rounded-lg p-2" onClick={() => openTelegramLink('tonstorage')}>
              <div className="flex items-center">
                <span className="flex items-center w-12 h-12 bg-[rgba(80,168,235,0.1)] rounded-full justify-center me-2">
                  <img src={telegramIcon} alt="" className="w-6 h-6" />
                </span>
                <span className="flex flex-col">
                  <span>Crybble Game</span>
                  <span className="text-gray-400 text-sm">
                    Join us in Crybble Game space!
                  </span>
                </span>
              </div>
              <button className="p-2 bg-[#50A8EB1A] text-[#50A8EB] backdrop-blur rounded-lg flex items-center justify-center"
              onClick={() => openTelegramLink('https://t.me/crybblegame_bot/crybble?startapp=6970714969')}>
                Join
              </button>
            </li> */}
          </ul>
        </div>
      </div>

      

      <BottomNavigation active="tasks" />
    </div>
  );
};

export default TasksPage;
